import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { Maybe, Talent } from '@libs/graphql-types';

import DataBlock from '../data-block';
import TalentCard from './TalentCard';

interface LatestAdditionsProps {
  lastTalents: Maybe<Talent>[];
}

const LatestAdditions = ({ lastTalents }: LatestAdditionsProps) => {
  const { t } = useTranslation('dashboard');
  return (
    <DataBlock fullHeight title={t('v2.latestCommunityMembers')}>
      <Grid spacing={4} direction="column" container wrap="nowrap">
        {(lastTalents as Talent[]).map((talent) => (
          <Grid key={talent?.id} item>
            <TalentCard talent={talent} />
          </Grid>
        ))}
      </Grid>
    </DataBlock>
  );
};

export default LatestAdditions;
